import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export interface SpecialOfferItem {
  id: number;
  codename128: string;
  sn_name: string;
  url_image: string;
  quanty: number;
  cost: number;
  cost_sold: number;
  discount_percent: number;
  start_offert: string;
  end_offert: string;
  avalible: number;
  recommend: number;
  isactive: number;
  time_left: string;
  available: number;
}

export const SPECIALOFFERT_QUERY_KEY = ['specialoffert'] as const;

export async function fetchSpecialOffers(): Promise<SpecialOfferItem[]> {
  const { data } = await api.get<{ status: string; offers: SpecialOfferItem[] }>(
    '/api/v1/specialoffert',
  );
  return data.offers ?? [];
}

export function useSpecialOffers() {
  return useQuery({
    queryKey: SPECIALOFFERT_QUERY_KEY,
    queryFn: fetchSpecialOffers,
    staleTime: 60_000,
    placeholderData: (prev) => prev,
  });
}

export function useSpecialOfferMutations() {
  const queryClient = useQueryClient();

  const buyOffer = useMutation({
    mutationFn: async (payload: { codename128: string; quantity: number; cost: number }) => {
      const { data } = await api.post<{ success: boolean; message: string }>(
        '/api/v1/specialoffert/buy',
        payload,
      );
      return data;
    },
    onSuccess: (data) => {
      if (data.success) {
        void queryClient.invalidateQueries({ queryKey: SPECIALOFFERT_QUERY_KEY });
      }
    },
  });

  return { buyOffer };
}

export function prefetchSpecialOffers(queryClient: ReturnType<typeof useQueryClient>): void {
  void queryClient.prefetchQuery({
    queryKey: SPECIALOFFERT_QUERY_KEY,
    queryFn: fetchSpecialOffers,
    staleTime: 60_000,
  });
}
